import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import Flex from '../../layouts/Flex';

const DecorationDot = styled(Flex)(
  css({
    size: 'decorationLine.circleDot.small',
    borderRadius: '100%',
    backgroundColor: 'brandPrimary.1',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  }),
  ({ color }) =>
    css(color ? { backgroundColor: `decorationLine.${color}` } : {}),
  variant({
    prop: 'decorationSize',
    variants: {
      small: { size: 'decorationLine.circleDot.centralCircle.small' },
      base: { size: 'decorationLine.circleDot.centralCircle.base' },
      big: { size: 'decorationLine.circleDot.centralCircle.big' },
    },
  })
);

export default DecorationDot;
